module.exports = __webpack_public_path__ + "media/images/emblems/Lens_(Switzerland)-coat_of_arms-1c6d54021037e96e44707b1abacbae69.svg";